import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { networkSlice, selectIsRunning } from 'features/network/networkSlice';
import { selectMatchEvents } from 'features/match/matchSlice';
import MatchEvent from 'interfaces/matchEvent';
import { getNetworkStatus, retryErrorEvents } from 'features/network/thunks';
import NetworkStatus from 'enums/networkStatus';
import { MatchEventStatus } from '../../enums/matchEventStatus';
import { useAppDispatch } from '../../hooks/hooks';

const NETWORK_TIMEOUT = 10000;

const NetworkWatcher: React.FC = () => {
  const dispatch = useAppDispatch();
  const { setRunning } = networkSlice.actions;
  const [networkWatchCount, setNetworkWatchCount] = useState(0);

  const isRunning = useSelector(selectIsRunning);
  const errorMatchEvents = useSelector(selectMatchEvents).filter(
    (event: MatchEvent) =>
      event?.internal?.status &&
      [MatchEventStatus.ERROR, MatchEventStatus.DELETE_ERROR].indexOf(event.internal.status) > -1,
  );

  const watchWorker = async () => {
    if (isRunning) {
      console.log('A network worker is running, skipping');
      return;
    }

    if (!errorMatchEvents.length) return;
    dispatch(setRunning(true));
    const response = await getNetworkStatus();

    if (response['payload'] && response['payload']['status'] === NetworkStatus.DOWN) {
      console.log('Network is down, nothing to do');
      dispatch(setRunning(false));
      return;
    }

    await dispatch(retryErrorEvents(errorMatchEvents));

    dispatch(setRunning(false));
  };

  useEffect(() => {
    const timer = setTimeout(
      () => {
        watchWorker().then();
        setNetworkWatchCount(networkWatchCount + 1);
      },
      process.env.REACT_APP_NETWORK_TIMEOUT ? Number(process.env.REACT_APP_NETWORK_TIMEOUT) : NETWORK_TIMEOUT,
    );
    return () => clearTimeout(timer);
  }, [networkWatchCount]);

  return <></>;
};

export default NetworkWatcher;
